import { Menu } from 'actions/actionTypes';

export const moveMenu = (menu) => ({ type: Menu.MOVE_MENU, payload: menu });
export const resetMenuList = () => ({ type: Menu.RESET_MENU_LIST });

export const changeCurrentMenu = (isCurrentMenu) => ({ type: Menu.CHANGE_CURRENT_MENU, payload: { isCurrentMenu } });
export const changeOpenAsideMenu = (isAsideMenuOpen) => ({ type: Menu.CHANGE_ASIDE_MENU_OPEN, payload: { isAsideMenuOpen } });
export const hamburgerMenuOpen = (isHamburgerMenuOpen) => ({ type: Menu.HAMBURGER_MENU_OPEN, payload: { isHamburgerMenuOpen } });

export const loadMenuRequest = () => ({ type: Menu.LOAD_MENU_REQUEST });
export const loadMenuSuccess = (menuList) => ({ type: Menu.LOAD_MENU_SUCCESS, payload: menuList });
export const loadMenuFailure = (errorMessage) => ({ type: Menu.LOAD_MENU_FAILURE, payload: errorMessage });
